/* The button under an `EmptyState` — „Spróbuj ponownie", and whatever else a state offers.
 *
 * A stylesheet with no component, the same shape as `ghostButton.module.css` beside it, and it is
 * the GEOMETRY half of that split: the surface writes `ghost.ghost` for the treatment and this for
 * the box. `EmptyState` itself takes no action node on purpose — the sentence and the drawing are
 * the component's, and what the trainer can do about it is the caller's, standing under it.
 *
 * Promoted out of `pages/reports/ui/SurveyColumn.module.css` on 17 September 2026, when the matrix
 * and the review queue became the second and third surfaces with a retry under a state. The three
 * were about to be three byte-identical blocks, which is the failure mode the rule about a
 * declaration block appearing twice exists to catch.
 *
 * `background: var(--bg-card)` rather than transparent: every one of these stands on a card's own
 * ground and a ghost button reads as an outline against it.
 *
 * Heights are layout rather than design tokens (see stylelint.config.js). */

.stateAction {
  display: inline-flex;
  align-items: center;
  height: var(--h-control);
  padding: var(--space-0) var(--space-3);
  font-family: var(--font-body);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  letter-spacing: var(--ls-heading);
  background: var(--bg-card);
  border-radius: var(--radius-sm);
}
